export const percentageFormatter = {
  format: (value: number | bigint): string | null => {
    if (typeof value !== "number" || isNaN(value)) {
      return null
    }
    return new Intl.NumberFormat("en-US", {
      style: "percent"
    }).format(value)
  }
}

export const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  useGrouping: true
})

export const tenthsFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  useGrouping: true,
  maximumFractionDigits: 1
})
